/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Suffix_HelpInputs */



/**
* | output |
* | --- |
* | "Appended to the original filename before the extension." |
*
* @param {Audio_Embed_Export_Suffix_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_suffix_help = /** @type {((inputs?: Audio_Embed_Export_Suffix_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Suffix_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouté au nom de fichier original avant l'extension.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wird vor der Dateiendung an den ursprünglichen Dateinamen angehängt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiunto al nome del file originale prima dell'estensione.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавляется к исходному имени файла перед расширением.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se añade al nombre de archivo original antes de la extensión.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在原始文件名的扩展名之前附加。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("拡張子の前に元のファイル名に追加されます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक्सटेंशन से पहले मूल फ़ाइल नाम में जोड़ा जाता है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicionado ao nome do arquivo original antes da extensão.")
	return /** @type {LocalizedString} */ ("Appended to the original filename before the extension.")
});